import { FC, useMemo } from "react";
import { DeepPartial } from "react-hook-form";
import { WrapWithStepperContext } from "../../../../../../../../components/stepper/context";
import { VerificationDTO } from "../../../../../../../../store/verification/models/dto/due-diligence";
import AddressStep from "../../../../common/pages/kyc-details/steps/address";
import IdentityStep from "../../../../common/pages/kyc-details/steps/identity";
import ProofOfAddressStep from "../../../../common/pages/kyc-details/steps/proof-of-address";
import { FormHorizontalLinearStepper } from "../../../../common/steppers";
import ResultPage from "./result-page";
import SelfieStep from "./selfie";
import UserInfo from "./user-info";

type FormType = VerificationDTO.Requests.DueDiligence.Form.Post.Final.T["kycRequests"][number];

export const IndividualKycRequest: FC<{
  setFilesUploaded: (b: boolean) => void;
  filesUploaded?: boolean;
  setData: (d: DeepPartial<FormType>) => void;
  data: DeepPartial<FormType>;
  numberOfKycs: number;
  index: number;
  goToNextKyc: () => void;
}> = ({
  setFilesUploaded,
  setData,
  data,
  filesUploaded,
  numberOfKycs,
  index,
  goToNextKyc,
}) => {
  const steps = useMemo(
    () => [
      {
        title: "User Details",
        content: UserInfo,
      },
      {
        title: "Address",
        content: AddressStep,
      },
      {
        title: "Face",
        content: SelfieStep,
      },
      {
        title: "ID Details",
        content: IdentityStep,
      },
      {
        title: "Proof of Address",
        content: ProofOfAddressStep,
      },
    ],
    []
  );

  return (
    <WrapWithStepperContext>
      <div style={{ width: "100%" }}>
        <FormHorizontalLinearStepper
          stepsProps={useMemo(
            () => ({
              setFilesUploaded,
              setData,
              data,
              filesUploaded,
            }),
            [setFilesUploaded, setData, data, filesUploaded]
          )}
          steps={steps}
          finalPage={
            <ResultPage
              numberOfKycs={numberOfKycs}
              index={index}
              goToNextKyc={goToNextKyc}
            />
          }
        />
      </div>
    </WrapWithStepperContext>
  );
};
